import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;
  background-color: white;
  box-shadow: 0 0 5px rgba(0,0,0,0.2);
`;
